import cryptoreadClient from "@/common/apiClient/cryptoreadClient";
import { cryptoReadState } from "@/slices/cryptoReadSlice";
import Image from "next/image";
import { EMAIL_CONTENT, THANK_YOU_PAGE_LINK } from "../common/constant";
const { useSelector, useDispatch } = require("react-redux")

const CREmailPop = ({showCRShowEmailPop, setCRShowEmailPop}) =>{
    const dispatch = useDispatch();
    const { showCREmail } = useSelector(cryptoReadState);
    

    const resendEmail = async () =>{
        try{
            const result = await cryptoreadClient.getSubscribe(showCREmail);

            if(result?.message === 're-subscribe success'){
                window.location.href = THANK_YOU_PAGE_LINK;
            }
        }catch (e) {
            console.error(e);
        }
    };

    return(
        <div className={`modal ${ showCRShowEmailPop? 'act z-[10]':''}`}>
            {/* 關閉用 */}
            <div
                className="close-bg"
                onClick={() => dispatch(setCRShowEmailPop(false))}
            />
            <div className="inner max-w-[540px] px-[35px] py-[50px]  flex flex-col center-center text-center text-black gap-y-[30px]">
                <p className="text-h2">{EMAIL_CONTENT?.[0]}</p>
                <div className="w-[147px] h-[138px]">
                    <Image
                        alt="mail-image"
                        width={147}
                        height={138}
                        src={"/images/cryptoread/email.svg"}
                        className="absolute"
                    />
                </div>
                <div>
                    <p className="text-bd2n text-red0">{EMAIL_CONTENT?.[1]}</p>
                    <p className="text-bd1m">{EMAIL_CONTENT?.[2]+ showCREmail +EMAIL_CONTENT?.[3] }</p>
                </div>

                <div>
                    <p className="text-bd1b">{EMAIL_CONTENT?.[4]}</p>
                    <p className="text-bd1m">
                        <span>{EMAIL_CONTENT?.[5]}&nbsp;</span>
                        <button onClick={resendEmail}>
                            <span className="text-red0">{EMAIL_CONTENT?.[6]}</span>
                        </button>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default CREmailPop;